import React from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { IoIosArrowBack } from "react-icons/io";
import { playSong } from '../../common/actions/common.actions';

export const Share = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const handleSongClick = () => {
        dispatch(playSong());
    };

    const handleClick = () => {
        handleSongClick();
        navigate('/dashboard');
    };

    return (
        <div className="w-full h-[100dvh] flex flex-col bg-slate-100 dark:bg-slate-900">
            <div className="flex pt-4 justify-start items-start bg-slate-100 dark:bg-slate-900 z-30">
                <button
                    className="left-10 w-10 h-10 mr-3 rounded-full drop-shadow-lg flex justify-start items-start text-blue-700 text-4xl"
                    onClick={handleClick}
                >
                    <IoIosArrowBack size={25} className="text-content ml-4" />
                </button>
                <div className="flex justify-center items-center font-bold text-primary dark:text-white">
                    Live
                </div>
            </div>

            <div className="flex-1 -mt-16 -mb-10 w-full relative">
                <div className="absolute inset-0 overflow-y-auto" style={{ WebkitOverflowScrolling: 'touch', overscrollBehavior: 'contain' }}>
                    <iframe
                        title="Live football videos"
                        src="https://www.scorebat.com/embed/"
                        sandbox="allow-scripts allow-same-origin allow-presentation"
                        allow="autoplay; fullscreen"
                        allowFullScreen
                        className="w-full h-full"
                    />

                </div>
            </div>
        </div>
    );
};
